import React, { useState, useEffect } from "react";
import { useParams } from 'react-router-dom';
import './Product.css'
import axios from "axios";
import SiteNavBar from '../navigation/SiteNavBar';
import Footer from '../footer/Footer';
import CopyRight from '../footer/CopyRight';
import '../../../assets/css/main.css'
import '../../../assets/bootstrap/css/bootstrap.min.css'
import { config } from '../../../config';
import { formatProductDescription } from '../../../utils/productDescription';

const Product = () => {
    const { id } = useParams(); // Retrieve 'id' parameter from URL
    const [product, setProduct] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        // Replace `your-api-endpoint` with your actual API endpoint URL
        const url = `${config.API_BASE}/api/products/` + id;
        axios({
            method: 'GET',
            url: url
        })
            .then((response) => {
                console.log(response.data)
                setProduct(response.data);
                setLoading(false);
            })
            .catch((error) => {
                setError("Failed to fetch single items");
                setLoading(false);
            });
    }, []);

    // Find the product by id
    //const product = productArray.find(item => item._id === id);
    //const cartUrl = "/cart/" + product._id

    if (!product) {
        return <p>Product not found</p>;
    }

    return (
        <div>
            <SiteNavBar />
            <div className="hero-area hero-bg" style={{ paddingTop: '3%' }}>
                <div className="container">
                    <div className="row">
                        <div className="col-lg-9 offset-lg-2 text-center">
                            <div className="hero-text">
                                <div className="hero-text-tablecell" style={{ padding: '15% 0' }}>
                                    <p className="subtitle" style={{ fontSize: '20px' }}>Farmers Marketspace</p>
                                    <h1>SINGLE PRODUCT</h1>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="single-product mt-150 mb-150">
                <div class="container">
                    <div class="row">
                        <div class="col-md-5">
                            <div class="single-product-img">
                                <img src={product.media[0]} alt={product.title} />
                            </div>
                        </div>
                        <div class="col-md-7">
                            <div class="single-product-content">
                                <h3>{product.title}</h3>
                                <p class="single-product-pricing"><span>Per {product.unit}</span> ${Number(product.cost).toFixed(2)}</p>
                                <div
                                    className="product-description"
                                    dangerouslySetInnerHTML={formatProductDescription(product.description)}
                                />
                                <div class="single-product-form">
                                    <form action="#">
                                        <input type="number" placeholder="0" />
                                    </form>
                                    <a href={"/cart/" + product._id} class="cart-btn"><i className="fas fa-shopping-cart"></i>Add to Cart</a>
                                    <p><strong>Category: </strong>{product.category.title}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
            <CopyRight />
        </div>
    )
}

export default Product;